import { render, staticRenderFns } from "./vlabel.vue?vue&type=template&id=9a67d94a&scoped=true"
import script from "./vlabel.vue?vue&type=script&lang=js"
export * from "./vlabel.vue?vue&type=script&lang=js"
import style0 from "./vlabel.vue?vue&type=style&index=0&id=9a67d94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67d94a",
  null
  
)

export default component.exports